/**
 * Used by all the steps component.
 *
 * This mixin make use of
 * - [this.editable]
 *   editable is computed and provided by default.
 * - [this.rules]
 *   rules used by progress tracker and form validation
 */
import SUBMISSION_STATUS from '@/assets/data/viddsee/submissionStatus';
import rulesLibrary from '../rules';

const stepMixin = {
  computed: {
    editable() {
      return SUBMISSION_STATUS.getInfo(this.value.status).editable;
    },
    editablePreReview() {
      return SUBMISSION_STATUS.TYPE[this.value.status] <= SUBMISSION_STATUS.TYPE.pending;
    },
  },
  created() {
    // Compute current step index of the child
    const currentStepIndex = parseInt(this.$route.path.split('/').splice(-1), 10) - 1;
    if (!Number.isInteger(currentStepIndex)) {
      throw new Error('Unable to compute current step index. Need to re-evaluate the implementation.');
    }

    // Set up rules for this step
    this.rules = rulesLibrary.rules[currentStepIndex];
    if (this.rules == null) {
      throw new Error('No rules were specified for this step. Please provide at least an empty object for this step.');
    }
  },
};

export default stepMixin;



// WEBPACK FOOTER //
// ./src/components/Submission/Mixins/stepMixin.js